// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial State
import initialState from './initialState'

// Reducers
import { reducers as operatorReducers } from 'hfty-operator-orders'
import { reducers as orderTestsReducers } from 'hfty-operator-order-tests'

export default createReducer({
  ...initialState,
  orderTestsOperation: {},
}, {
  ...operatorReducers,
  ...orderTestsReducers,
})
